export const isE2E = import.meta.env.VITE_E2E === "1";

export const externalServicesEnabled = !isE2E;
